import { DefaultState, DropdownItem } from 'store/types';
import { Filters } from 'store/types';

export const GET_CLIENTS_FOR_FILTER_REQUEST = 'GET_CLIENTS_FOR_FILTER_REQUEST';
export const GET_CLIENTS_FOR_FILTER_SUCCESS = 'GET_CLIENTS_FOR_FILTER_SUCCESS';
export const GET_CLIENTS_FOR_FILTER_FAILURE = 'GET_CLIENTS_FOR_FILTER_FAILURE';

export interface GetClientsForFilterParams {
  filters: Filters;
  paging: {
    page: number;
    pageSize: number;
  };
};

export interface GetClientsForFilterData {
  rows: DropdownItem[];
  totalCount: number;
}

export type GetClientsForFilterState = DefaultState & {
  contents?: GetClientsForFilterData;
};

interface ReadGetClientsForFilterRequest {
  type: typeof GET_CLIENTS_FOR_FILTER_REQUEST;
};

interface ReadGetClientsForFilterSuccess {
  type: typeof GET_CLIENTS_FOR_FILTER_SUCCESS,
  contents: GetClientsForFilterData;
}

interface ReadGetClientsForFilterFailure {
  type: typeof GET_CLIENTS_FOR_FILTER_FAILURE;
}

export type GetClientsForFilterActionTypes = ReadGetClientsForFilterRequest | ReadGetClientsForFilterSuccess | ReadGetClientsForFilterFailure;